export class SSOUtils {
  generateNonce(length: number) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let nonce = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      nonce += characters.charAt(randomIndex);
    }
    return nonce;
  }

  isValidOrigin(origin: string) {
    const allowedDomains = ['mheducation.com', 'boardsbeyond.com', 'mcgrawhill.com'];
    let hostname: string;
    try {
      // Prepend scheme if missing so URL() can parse bare hostnames (e.g. "boardsbeyond.com")
      const url = new URL(origin.includes('://') ? origin : `https://${origin}`);
      hostname = url.hostname;
    } catch {
      return false;
    }
    return (
      hostname === 'localhost' ||
      allowedDomains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`))
    );
  }

  fillInitialBarIfNotPresent(data: any) {
    if (data && data.redirectUrl) {
      return (<string>data.redirectUrl).startsWith('/') ? data.redirectUrl : `/${data.redirectUrl}`;
    }
    return '';
  }
}

